export default __webpack_public_path__ + "static/media/seo.04b022c3.svg";